import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
} from "@mui/material";
import { InputForm } from "components/ui/inputForm";
import { toInputUppercase } from "helpers/helpers";
import { useServiceInscripcionCursos } from "hooks/inscripcionCursos/useInscripcionCursos";
import { useAuthStore } from "hooks/useAuthStore";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { IconContext } from "react-icons";
import { BsCheckLg, BsFillXCircleFill, BsPencilSquare } from "react-icons/bs";

interface CursoProps {
  origen?: string;
}

export const ModalDatosInscripcion = ({ origen }: CursoProps) => {
  const methods = useForm();
  const { user } = useAuthStore();
  const {
    cursoSelecccionado,
    loadingEnviado,
    openModalInscripcion,
    irInscripcion,
    setIrInscripcion,
    saveInscripcionCurso,
    setOpenModalInscripcion,
    setCursoSeleccionado,
    setEnviado,
    startConfirmarInscripcion,
  } = useServiceInscripcionCursos();

  const onSubmitForm = (data: any) => {
    let body = {
      ...data,
      cveUsuario: user?.session?.cveUsuario ? user?.session?.cveUsuario : null,
      idCurso: cursoSelecccionado,
    };
    saveInscripcionCurso(body);
    methods.reset();
  };

  useEffect(() => {
    if (user) {
      methods.setValue("nombreCompleto", user?.fullName);
      methods.setValue("correoElectronico", user?.emailAlternativo);
    }
  }, []);

  const handleCloseModal = () => {
    setOpenModalInscripcion(false);
    setCursoSeleccionado(null);
    setIrInscripcion(false);
    if (origen === "login") {
      setEnviado(false);
    } else {
      setEnviado(true);
    }
  };

  const handleIrRegistro = () => {
    setIrInscripcion(true);
  };

  const handleRelacionarFolio = () => {
    let body = {
      cveUsuario: user?.session?.cveUsuario ? user?.session?.cveUsuario : null,
      folio: methods.getValues("folio"),
    };
    startConfirmarInscripcion(body);
    methods.setValue("folio", "");
  };

  return (
    <>
      <Dialog open={openModalInscripcion} onClose={handleCloseModal} fullWidth>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmitForm)}>
            <Divider />
            <DialogContent>
              <Card>
                <CardHeader
                  title="DATOS PERSONALES"
                  style={{ backgroundColor: "#7c1f0d", color: "#fff" }}
                />
                <Divider />
                {irInscripcion || origen === "login" ? (
                  <CardContent className=" overflow-y-auto mx-auto">
                    <div className="mx-auto">
                      <div className="card col-12 ">
                        <Grid
                          xs={12}
                          sm={12}
                          md={12}
                          lg={10}
                          xl={10}
                          className="mx-auto w-full mt-4"
                        >
                          <div>
                            <span className="text-sm font-semibold text-gray-700">
                              <strong>Llena los sigueintes campos</strong>
                            </span>
                          </div>
                        </Grid>
                        <Grid
                          xs={12}
                          sm={12}
                          md={12}
                          lg={10}
                          xl={10}
                          className="mx-auto w-full mt-6"
                        >
                          <InputForm
                            onInput={toInputUppercase}
                            label="Nombre Completo"
                            name="nombreCompleto"
                            disabled={loadingEnviado}
                            size="small"
                            className="w-full"
                            rules={{
                              required: {
                                value: true,
                                message: "El Nombre es un campo requerido",
                              },
                            }}
                          />
                        </Grid>
                        <Grid
                          xs={12}
                          sm={12}
                          md={12}
                          lg={10}
                          xl={10}
                          className="mx-auto w-full mt-4"
                        >
                          <InputForm
                            label="Correo Electrónico"
                            name="correoElectronico"
                            size="small"
                            disabled={loadingEnviado}
                            className="w-full"
                            rules={{
                              required: {
                                value: true,
                                message: "El Correo es un campo requerido",
                              },
                              pattern: {
                                value:
                                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                message:
                                  "Dirección de correo inválida. E.g. example@email.com",
                              },
                              validate: (value: any) => {
                                if (value?.trim() === "") {
                                  return "El campo no puede contener solo espacios en blanco";
                                }
                                const localPart = value.split("@")[0]; // Extrae la parte antes de '@'
                                if (/^[._%+-]+$/.test(localPart)) {
                                  return "El correo no puede contener solo caracteres especiales antes del '@'";
                                }
                                return true;
                              },
                            }}
                          />
                        </Grid>
                        <Grid
                          xs={12}
                          sm={12}
                          md={12}
                          lg={10}
                          xl={10}
                          className="mx-auto w-full mt-4"
                        >
                          <InputForm
                            label="Telefono"
                            name="telefono"
                            size="small"
                            disabled={loadingEnviado}
                            className="w-full"
                            maxLength={10}
                            rules={{
                              required: {
                                value: true,
                                message: "El Telefono es un campo requerido",
                              },
                              pattern: {
                                value: /^[0-9]{10}$/,
                                message: "El teléfono debe contener 10 dígitos",
                              },
                              validate: (value: any) => {
                                if (
                                  /^(0{10}|1{10}|2{10}|3{10}|4{10}|5{10}|6{10}|7{10}|8{10}|9{10})$/.test(
                                    value
                                  )
                                ) {
                                  return "El teléfono no puede contener 10 dígitos consecutivos";
                                }
                                return true;
                              },
                            }}
                          />
                        </Grid>
                      </div>
                    </div>
                  </CardContent>
                ) : origen !== "login" ? (
                  <CardContent>
                    <div className="mx-auto w-full mt-2">
                      <h4>¡IMPORTANTE!</h4>
                    </div>
                    <div className="mx-auto w-full mt-2">
                      <p>
                        Si se inscribió en el curso sin iniciar sesión, ingrese
                        su No. de FOLIO que se genero en su registro y haga clic
                        en "Aceptar". De lo contrario, haga clic en el botón "Ir
                        a Registro".
                      </p>
                    </div>
                    <div className="mx-auto w-full mt-4">
                      <InputForm
                        label="No. de Folio"
                        name="folio"
                        size="small"
                        className="w-full"
                      />
                    </div>
                  </CardContent>
                ) : null}
              </Card>
            </DialogContent>
            {irInscripcion || origen === "login" ? (
              <DialogActions>
                <Grid
                  xs={12}
                  sm={12}
                  md={4}
                  lg={4}
                  xl={4}
                  className="mx-auto mt-4 py-8"
                >
                  <Button
                    type="button"
                    onClick={handleCloseModal}
                    fullWidth
                    className="py-8 mt-4"
                    disabled={loadingEnviado}
                    style={{
                      backgroundColor: "#b2b9c5",
                      color: "#fff",
                      fontSize: "1rem",
                    }}
                    startIcon={
                      <IconContext.Provider value={{ className: "" }}>
                        <BsFillXCircleFill />
                      </IconContext.Provider>
                    }
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid
                  xs={12}
                  sm={12}
                  md={4}
                  lg={4}
                  xl={4}
                  className="mx-auto mt-4 py-8"
                >
                  <Button
                    type="submit"
                    fullWidth
                    className="py-8 mt-4"
                    disabled={loadingEnviado}
                    style={{
                      backgroundColor: "#265ab4",
                      color: "#fff",
                      fontSize: "1rem",
                    }}
                    startIcon={
                      <IconContext.Provider value={{ className: "" }}>
                        <BsPencilSquare />
                      </IconContext.Provider>
                    }
                  >
                    {loadingEnviado ? "Enviando..." : "Enviar"}
                  </Button>
                </Grid>
              </DialogActions>
            ) : origen !== "login" ? (
              <DialogActions>
                <Grid
                  xs={12}
                  sm={12}
                  md={4}
                  lg={4}
                  xl={4}
                  className="mx-auto mt-4 py-8"
                >
                  <Button
                    type="button"
                    onClick={handleIrRegistro}
                    fullWidth
                    className="py-8 mt-4"
                    style={{
                      backgroundColor: "#b2b9c5",
                      color: "#fff",
                      fontSize: "1rem",
                    }}
                    startIcon={
                      <IconContext.Provider value={{ className: "" }}>
                        <BsPencilSquare />
                      </IconContext.Provider>
                    }
                  >
                    Ir a Registro
                  </Button>
                </Grid>
                <Grid
                  xs={12}
                  sm={12}
                  md={4}
                  lg={4}
                  xl={4}
                  className="mx-auto mt-4 py-8"
                >
                  <Button
                    type="button"
                    fullWidth
                    className="py-8 mt-4"
                    onClick={handleRelacionarFolio}
                    style={{
                      backgroundColor: "#265ab4",
                      color: "#fff",
                      fontSize: "1rem",
                    }}
                    startIcon={
                      <IconContext.Provider value={{ className: "" }}>
                        <BsCheckLg />
                      </IconContext.Provider>
                    }
                  >
                    {"Aceptar"}
                  </Button>
                </Grid>
              </DialogActions>
            ) : null}
          </form>
        </FormProvider>
      </Dialog>
    </>
  );
};
